import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecoveryChangePasswordFormComponent } from './recovery-change-password-form.component';
import {DxButtonModule, DxLoadPanelModule, DxTextBoxModule, DxValidationGroupModule, DxValidatorModule} from 'devextreme-angular';



@NgModule({
  declarations: [RecoveryChangePasswordFormComponent],
  imports: [
    CommonModule,
    DxValidationGroupModule,
    DxLoadPanelModule,
    DxButtonModule,
    DxTextBoxModule,
    DxValidatorModule
  ],
  exports: [RecoveryChangePasswordFormComponent]
})
export class RecoveryChangePasswordFormModule { }
